import { render, staticRenderFns } from "./StudentTransferComponent.vue?vue&type=template&id=612eb458&scoped=true&"
import script from "./StudentTransferComponent.vue?vue&type=script&lang=js&"
export * from "./StudentTransferComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612eb458",
  null
  
)

export default component.exports